import React from 'react';
import { Box, Button, Paper, Typography, useMediaQuery } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import CalendarIcon from '../../kit/icons/CalendarIcon';
import ClockIcon from '../../kit/icons/ClockIcon';
import Status from '../Status/Status';
import { sendYandexMetrikaEvent } from '../../helpers/yandexMetrika';
import { styles } from './styles';

export default function ProgramCard({
  program: {
    name,
    formats,
    entranceInterview,
    link,
    ymSubmitEventType,
    courseType,
    length,
  },
  bg,
}) {
  const isBelowSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Paper elevation={0} sx={styles.root}>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          zIndex: 2,
          py: 3,
          px: { xs: 2, lg: 3 },
        }}
      >
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={styles.header}>
            <Typography
              variant="desktopH4"
              color={
                courseType === 'Подготовительная программа' ||
                courseType === 'Бесплатный курс'
                  ? 'kit.text.main'
                  : 'kit.text.h'
              }
              sx={styles.name}
            >
              {' '}
              {name}
            </Typography>
            <Status
              styleProp={{
                color: 'kit.text.secondary',
                backgroundColor: 'kit.background.lightpurple',
                border: 'none',
                borderRadius: 1,
                textTransform: 'lowercase',
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: 11,
                width: 61,
                height: 19,
                p: '2px !important',
              }}
            >
              {'<с нуля>'}
            </Status>
          </Box>
          {formats && (
            <Typography
              variant="desktopP3"
              color={'kit.text.main'}
              sx={{ fontSize: { xs: 11, md: 14 }, mb: 0.5 }}
            >
              {formats.length > 1 ? 'Форматы:' : 'Формат:'}
            </Typography>
          )}
          {formats?.map((format) => (
            <Typography
              variant="desktopP3"
              sx={{ fontSize: { xs: 11, md: 14 }, mb: 0.5 }}
              key={format}
            >
              {'•'} {format}
            </Typography>
          ))}
          {entranceInterview && (
            <Typography
              variant="desktopP3Helper"
              color={'kit.text.secondary'}
              sx={{ fontSize: { xs: 11, md: 12 }, my: 2 }}
            >
              {entranceInterview}
            </Typography>
          )}
          <Box sx={styles.lengths}>
            {length.map((item, index) => {
              const icons = [CalendarIcon, ClockIcon];
              const Icon = icons[index];
              return item ? (
                <Box key={item} sx={styles.length}>
                  <Icon
                    sx={{ width: 16, height: 16 }}
                    color={
                      courseType === 'Подготовительная программа' ||
                      courseType === 'Бесплатный курс'
                        ? '#0f0f0f'
                        : '#4520ab'
                    }
                  />
                  <Typography
                    variant="mobileP2"
                    sx={(theme) => ({
                      ml: 1,
                      [theme.breakpoints.down('lg')]: { fontSize: 14 },
                    })}
                    color="kit.text.main"
                  >
                    {item}
                  </Typography>
                </Box>
              ) : null;
            })}
          </Box>

          <Box
            sx={{
              mt: 'auto',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Link
              href={link}
              sx={styles.link}
              target={link.startsWith('http') ? '_blank' : '_self'}
            >
              <Button
                component="div"
                variant="kitPrimary"
                size={isBelowSm ? 'smallest' : 'medium'}
                onClick={() => sendYandexMetrikaEvent(ymSubmitEventType)}
              >
                ПОДРОБНЕЕ
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          width: '102%',
          height: '102%',
          top: -2,
          left: -2,
        }}
      >
        {bg}
      </Box>
    </Paper>
  );
}
